import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS, type SupportedLang } from '../i18n';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (
    SUPPORTED_LANGS.includes(i18n.resolvedLanguage as SupportedLang)
      ? i18n.resolvedLanguage
      : 'de'
  ) as SupportedLang;

  return (
    <div role="group" aria-label={t('common.language')} className="inline-flex rounded-md border border-slate-300 dark:border-slate-600 overflow-hidden">
      {SUPPORTED_LANGS.map((lang) => (
        <button
          key={lang}
          type="button"
          onClick={() => void i18n.changeLanguage(lang)}
          aria-pressed={lang === current}
          className={
            'px-3 py-1.5 text-sm font-medium uppercase tracking-wide ' +
            (lang === current
              ? 'bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900'
              : 'bg-white text-slate-700 hover:bg-slate-100 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800')
          }
        >
          {lang}
        </button>
      ))}
    </div>
  );
}
